import { u, styled } from '../../../../shared/theming-sc'
import PrimaryButton from '../../../primary-button/PrimaryButton'

const HeaderSearchMobileWrapper = styled.div`
    position: fixed;
    width: 100%;
    box-sizing: border-box;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: white;
    z-index: 10000000;
`

const HeaderSearchHead = styled.div`
    position: absolute;
    top: 0;
    width: 100%;
    box-sizing: border-box;
    border-bottom: 1px solid ${u.getColor('greyMuted')};
    padding: ${u.getSpacing('large')}px;
`

const HeaderSearchClose = styled.a`
    display: block;
    position: absolute;
    top: ${u.getSpacing('large')}px;
    right: ${u.getSpacing('large')}px;
    width: 12px;
    height: 12px;
`

const HeaderSearchBody = styled.div`
    width: 100%;
    padding: ${u.getSpacing('large')}px;

    position: absolute;
    top: 156px;
    bottom: 100px;
    left: 0;
    right: 0;
    overflow-x: hidden;
    overflow-y: auto;
    height: auto;
    max-height: none;
`

const HeaderSearchFoot = styled.div`
    width: 100%;
    padding: ${u.getSpacing('large')}px;
    border-top: 1px solid ${u.getColor('greyMuted')};
    float: left;
    position: absolute;
    bottom: 0;
    height: 100px;
`

const HeaderSearchFootLink = styled.a`
    color:${u.getColor('greyDark')};
    font-size: ${u.getFontSize('md')};
    font-weight: 500;
    text-decoration: underline;
`

const HeaderSearchFootButton = styled(PrimaryButton)`
    float: right;
    position: relative;
    top: -${u.getSpacing('small')}px;
    margin-left: ${u.getSpacing('small')}px;
`

const HeaderSearchInput = styled.input`
    position: relative;
    border: solid 1px ${u.getColor('greyMuted')};
    background-color: white;
    border-radius: 5px;
    padding: ${u.getSpacing('small')}px 40px ${u.getSpacing('small')}px ${u.getSpacing('small')}px;
    color: ${u.getColor('greyDark')};
    font-size: ${u.getFontSize('md')};
    width: 100%;
    margin: ${u.getSpacing('small')}px 0;

    &:focus {
        border: solid 1px ${u.getColor('greyDark')};

          ::placeholder{
            color: rgba(0, 0, 0, 0)
        }
    }
`

const HeaderSearchIcon = styled.span`
    position: absolute;
    right: 50px;
    top: 77px;
    display: block;
    width: 30px;
    height: 30px;
`

export {
  HeaderSearchMobileWrapper,
  HeaderSearchHead,
  HeaderSearchClose,
  HeaderSearchBody,
  HeaderSearchInput,
  HeaderSearchIcon,
  HeaderSearchFoot,
  HeaderSearchFootButton,
  HeaderSearchFootLink
}
